import {
  createEmptyRechteStorage,
  isRechteStorageVorhanden,
  speichereRechteStorage,
} from '@/persistence/RechteStorage';
import type { RouteLocationNormalized } from 'vue-router';
import { ladeNavigationStorage, speichereNavigationStorage } from '@/persistence/NavigationStorage';
import { useSharedApi } from '@/shared/api/useSharedApi.ts';

/**
 * Hole eigene Rechte, falls nicht im RechteStorage vorhanden.
 * Falls der PartnerService kaputt ist, bleibt der RechteStorage leer (isRechteStorageVorhanden() liefert false) und
 * es wird beim nächsten Routing erneut probiert, die Rechte zu laden, bis es evtl. mal klappt
 */
export async function ladeRechteAusPartnerServiceInDenRechteStorage() {
  if (!isRechteStorageVorhanden()) {
    const partnerResponseEigene = await useSharedApi().sharedNutzerverwaltung.holeEigeneRechte();
    const rechteStorage = createEmptyRechteStorage();
    rechteStorage.eigeneRechte = partnerResponseEigene;
    speichereRechteStorage(rechteStorage);
  }
}

/**
 * Speichert Route im alten Navigation Storage
 * @param to
 * @param from
 * @deprecated In Zukunft wollen wir den Pinia Store nutzen
 */
export function setRouteNamen(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  const navigationStorage = ladeNavigationStorage();
  navigationStorage.routeNamen = [to.name.toString(), from?.name?.toString()];
  speichereNavigationStorage(navigationStorage);
}
